import { render } from "./jieduan-form.vue?vue&type=template&id=3dc74146&scoped=true"
import script from "./jieduan-form.vue?vue&type=script&lang=js"
export * from "./jieduan-form.vue?vue&type=script&lang=js"

import "./jieduan-form.vue?vue&type=style&index=0&id=3dc74146&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc74146"]])

export default __exports__